/**
 * @module app.prospection.store.appointmentCtrl
 */

define(['angular', 'moment'], function(angular, moment) {


    function AppointmentCtrl($scope, $rootScope, appointmentService, $root, userService, walletService, storeService, Notification) {
        let self = this;
        let store = $scope.storeCtrl.store;
        store.appointments = [];
        self.error = {};
        self.appointmentPurposes = [];
        self.appointmentDurations = [];
        self.appointmentSources = [];
        self.appointProvenances = [];
        self.appointment = {};
        self.showAppointment = false;
        self.showNewAppointmentText = false;
        self.appointmentAdded = 'Le rendez-vous a été enregistré';
        self.noAppointments = 'Aucun rendez-vous à afficher pour ce client';
        self.isAppointmentFormDisabled = false;
        self.isTeleproForm = false;
        self.isCsdForm = false;
        self.isHoursDisabled = true;

        // Get store's appointments
        self.getAppointments = function getAppointments() {
            appointmentService
                .getAppointments(store.identifiant_magasin)
                .then(function(appointments) {
                    store.appointments = [];
                    if (appointments.length !== 0) {
                        var callIds = appointments.map(function(appointment) {
                            return appointment.call_id;
                        });
                        // Find calls associated to appointments and their contact_date
                        appointments.map(function(rdv) {
                            if (rdv.appointment_purpose_designation.indexOf('Appel') !== -1) {
                                rdv.start_date = null;
                                rdv.appointment_user = null;
                            }
                            store.appointments.push(rdv);
                        });
                        store.appointments.sort(function(rdvA, rdvB) {
                            var dateA = rdvA.contact_date ? rdvA.contact_date : rdvA.start_date;
                            var dateB = rdvB.contact_date ? rdvB.contact_date : rdvB.start_date;
                            return moment(dateB, 'DD/MM/YYYY').diff(moment(dateA, 'DD/MM/YYYY'));
                        });
                    }
                })
                .catch(function(err) {
                    self.error = {
                        error: true,
                        class: 'alert-danger',
                        message:
                            'Une erreur est survenue' +
                            (err.statusText ? ' : [' + err.status + '] ' + err.statusText : '')
                    };
                });
        };

        self.getDisplayName = function (uid){
            const user =  userService.findPerson(uid);
            return user ? user.user.displayName : uid;
        }

        self.displayButton = function (index){
            let display = false
            if(index === 0 && store.appointments[index].comment === 'Relance automatique suite à démo.') {
                display = false;
            }else if (index === 0 && store.appointments[index].comment !== 'Relance automatique suite à démo.'){
                display = true;
            }else if(index === 1 && store.appointments[index-1].comment === 'Relance automatique suite à démo.') {
                display = true
            }
            return display;

        }

        // Get appointment purposes for the form
        self.getAppointmentPurposes = function getAppointmentPurposes() {
            let source = self.isTeleproForm ? 'P' : self.isCsdForm ? 'S' : 'C';
            appointmentService
                .getAppointmentPurposes(source)
                .then(function(appointmentPurposes) {
                    self.appointmentPurposes = appointmentPurposes;
                })
                .catch(function(err) {
                   $log.error('KYP : ' + err.data);
                });
        };

        // Get appointment durations for the form
        self.getAppointmentDurations = function getAppointmentDurations() {
            appointmentService
                .getAppointmentDurations()
                .then(function(appointmentDurations) {
                    self.appointmentDurations = appointmentDurations;
                })
                .catch(function(err) {
                    console.log('KYP : ' + err.data);
                });
        };

        // Get appointment source for the form
        self.getAppointmentSources = function getAppointmentSources() {
            appointmentService
                .getAppointmentSources()
                .then(function(appointmentSources) {
                    self.appointmentSources = appointmentSources.filter(source => source.label === 'Contact entrant' || source.label === 'Appel sortant');
                })
                .catch(function(err) {
                    console.log('KYP : ' + err.data);
                });
        };

        // Get appointment provenance for the form
        self.getAppointmentProvenances = function () {
            appointmentService
                .getAppointmentProvenances()
                .then(function(appointmentProvenances) {
                    self.appointmentProvenances = appointmentProvenances.filter(p => p.status === true);
                })
                .catch(function(err) {
                    console.log('KYP : ' + err.data);
                });
        };

        self.toggleAppointment = function() {
            self.showNewAppointmentText = false;
            self.showAppointment = !self.showAppointment;
        };

        /**
         * Enable the submit button if the previous date was in the future and the current is not
         */
        self.toggleSubmitButtonIfDateInThePast = function toggleSubmitButtonIfDateInThePast() {
            if (
                self.isAppointmentFormDisabled &&
                !moment(self.appointment.date).isAfter(moment().format('YYYY-MM-DD'))
            ) {
                self.isAppointmentFormDisabled = false;
            }
            if(self.isTeleproForm || self.isCsdForm){
                let hours = moment().hours();
                let minute = moment().minutes();
                self.isHoursDisabled = !(self.appointment.date !== undefined && self.appointment.date !== null);
                self.appointment.startDate = new Date(moment(self.appointment.date).add(hours, 'h').add(minute, 'm'));
                self.initEndTime();
            }
        };

        self.initEndTime = function() {
            self.appointment.endDate =
                self.appointment.startDate !== null
                    ? new Date(moment(self.appointment.startDate).add('15', 'm'))
                    : null;
            self.isAppointmentFormDisabled = false;
        };

        /**
         * Send the form to create a new appointment
         * When it is created, the new appointment is push at first of the collection of appointments
         */
        self.addAppointment = function addAppointment() {
            self.isAppointmentFormDisabled = true;
            self.error = {};

            if (!self.appointment.date && $rootScope.user.role === 'CSD') {
                self.error = {
                    error: true,
                    class: 'alert-danger',
                    message: 'Vous devez saisir une date.'
                };
                return;
            }
            if (moment(self.appointment.date).isAfter(moment().format('YYYY-MM-DD')) && !self.isTeleproForm && !self.isCsdForm) {
                self.error = {
                    error: true,
                    class: 'alert-danger',
                    message: 'Vous ne pouvez pas ajouter un rendez-vous dans le futur'
                };
                return;
            }
            let purpose = self.appointmentPurposes.find( a => a.id === self.appointment.appointmentPurpose); console.log(purpose);
            self.appointment.purposeDesignation = purpose ? purpose.designation : null;

            store = $scope.storeCtrl.store;
            appointmentService
                .addNewAppointment(store, self.appointment, self.isTeleproForm, self.isCsdForm)
                .then(function() {
                    self.getAppointments();
                    self.appointment = {};
                    self.showAppointment = false;
                    self.showNewAppointmentText = true;

                    // Reset the form validation
                    self.appointmentForm.$setUntouched();
                    self.isAppointmentFormDisabled = false;
                })
                .catch(function(err) {
                    console.log('KYP : ' + err.data);
                    self.isAppointmentFormDisabled = false;
                    self.error = {
                        error: true,
                        class: 'alert-danger',
                        message: err.data
                    };
                });
        };
        let _getStoreActivity = function(stat1_label){
            stat1_label = stat1_label === 'Tabac Presse' ? 'Tabac et Presse' : stat1_label;
            let act = self.activities.find(activity => {
                return activity.storeActivityLabel === stat1_label;
            });
            return act ? act.id : 1;
        }

        let _getOrderType = function(stat2_label){
            let net = self.networks.find(network => {
                console.log(network);
                return network.code === stat2_label.toUpperCase();
            });
            return net ? net.id : 1;
        }

        self.createBusiness = (appointment) => {
            let business = {
                businessStatusId: 1,
                scenarioTypeId: store.etat_magasin === 3 ? 1 : 2,
                nombreCaisse: 1,
                dateFinContrat: moment(storeService.getDateFinContrat(store)).isValid() ? moment(storeService.getDateFinContrat(store)).format('YYYY-MM-DD') : null,
                commentaireRds: $rootScope.user.role === 'RDS' ? appointment.comment : null,
                commentaireCs: $rootScope.user.role !== 'RDS' ? appointment.comment : null,
                moisSignature: null,
                moisRelance: null,
                dateRdv: null,
                provenance: $rootScope.user.role === 'RDS' ? 'Création manuelle RDS' : 'Création manuelle Télépro/CS',
                userIdRef: $rootScope.user.uid,
                clientId: store.client[0].id,
                managerRefId: $rootScope.user.parent.uid,
                orderTypeId: _getOrderType(store.stat2_label),
                storeActivityId: _getStoreActivity(store.stat1_label),
                dateModificationStatus: null,
                store: store
            };
            return walletService
                .createBusiness(business)
                .then(function(res) {
                    // Reset the form
                    res.department = res.addressPostalCode.slice(0, 2);
                    $scope.storeCtrl.store.wallet.push(res);
                    $scope.storeCtrl.store.client[0].id = res.clientId;
                    Notification.success('Affaire créée.');
                    location.reload(true);

                })
                .catch(err => {
                    console.log(err)
                    Notification.error('Une Erreur est survenue : ' + err.data);
                });
        };

        function _isTelepro() {
            self.isTeleproForm =
                ['TELEPRO', 'CS', 'RESP TELEPRO', 'AC', 'DC'].indexOf($root.user.role) !== -1;
        }

        function _isCsd() {
            self.isCsdForm =
                ['RESP CSD', 'CSD'].indexOf($root.user.role) !== -1;
        }


        function _getTeleproList() {
            userService.getUsersByRole('TELEPRO').then(res => {
                self.telepros = res;
                userService.getUsersByRole('CS').then(res => {
                    self.telepros = self.telepros.concat(res);
                    userService.getUsersByRole('RESP TELEPRO').then(res => {
                        self.telepros = self.telepros.concat(res);
                    });
                });
            });
        }

        function _getCSDList() {
            userService.getUsersByRole('CSD').then(res => {
                self.Csd = res;
                userService.getUsersByRole('RESP CSD').then(res => {
                    self.Csd = self.Csd.concat(res);
                })
            });
        }

        function _getBusinessForm() {
            return walletService
                .getBusinessForm()
                .then(data => {
                    self.types = data.scenarioTypes;
                    self.networks = data.orderTypes;
                    self.activities = data.storeActivities;
                    self.status = data.status;
                })
                .catch(err => {
                    Notification.error('Une erreur est survenue : ' + err.data);
                });
        }

        self.init = function init() {
            try{
                _isTelepro();
                _isCsd();
                _getTeleproList ();
                _getCSDList()
                self.getAppointmentDurations();
                self.getAppointments();
                self.getAppointmentPurposes();
                self.getAppointmentSources();
                self.getAppointmentProvenances();
                _getBusinessForm()
                self.error = {
                    error   : false,
                    message : ''
                };
            }catch(err){
                self.error = {
                    error   : true,
                    message : err
                };
            }finally{
                $scope.storeCtrl.loadingStore = false;
            }
        };

        function _offline() {
            _isTelepro();
            _isCsd();
            self.error = {
                error: true,
                message: 'Vous ne pouvez pas accéder aux rendez-vous en mode hors ligne'
            };
        }

        if ($root.online) {
            self.init();
        }
        else {
            _offline();
        }

        $root.$on('online', self.init);

        $root.$on('offline', _offline);

        return self;
    }

    AppointmentCtrl.$inject = ['$scope', '$rootScope', 'appointmentService', '$rootScope', 'userService', 'walletService', 'storeService', 'Notification'];

    angular.module('app.prospection.store.appointmentCtrl', []).controller('AppointmentCtrl', AppointmentCtrl);
});
